import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { PageHeader } from "@/widgets/page-header"
import { MarketingCampaignsTable } from "./marketing-campaings-table"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { useEffect, useRef } from "react"
import { MarketingCampaignsFilters } from "./marketing-campaigns-filters"
import { ToggleMarketingCampaignModal } from "@/features/update-marketing-campaigns"
import { fetchCampaigns, fetchChannels, selectChannelsFirstLoad, selectCurrentPage, selectCurrentSearch, selectMarketingCampaignsFirstLoad } from "@/entities/marketing-campaign"
import { PostMarketingCampaignResultsModal } from "@/features/update-marketing-campaigns/ui/post-marketing-campaign-results-modal"

export const MarketingCampaignsPage = () => {
    const isFirstRender = useRef(true)
    const campaignsFirstLoad = useAppSelector(selectMarketingCampaignsFirstLoad)
    const channelsFirstLoad = useAppSelector(selectChannelsFirstLoad)
    const dispatch = useAppDispatch()
    const page = useAppSelector(selectCurrentPage)
    const search = useAppSelector(selectCurrentSearch)

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchCampaigns())
        }
    }, [search, page])

    useEffect(() => {
        if (campaignsFirstLoad) dispatch(fetchCampaigns())
        if (channelsFirstLoad) dispatch(fetchChannels())
        isFirstRender.current = false
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Маркетинговые кампании" />
            <div className="flexbox">
                <PageSubtitle title="Список кампаний" />
                <MarketingCampaignsFilters />
                <MarketingCampaignsTable />
            </div>
            <ToggleMarketingCampaignModal />
            <PostMarketingCampaignResultsModal />
        </div>
    )
}